import React from 'react'
import {
  InstallationKeyRowStyled,
  InstallationKeyRowText,
  InstallationKeyRowKey,
} from './InstallationKeyRow.styled'
import { CopyTextButton, StyledText } from '@clickcease/cc-client-components-lib'

interface InstallationKeyRowProps {
  text: string
  keyCode: string
}

export const InstallationKeyRow = ({ text, keyCode }: InstallationKeyRowProps) => {
  return (
    <InstallationKeyRowStyled>
      <InstallationKeyRowText css={{ flex: 1 }}>{text}</InstallationKeyRowText>
      <InstallationKeyRowKey css={{ flex: 2 }}>
        <StyledText variant={'smallLight'}>{keyCode}</StyledText>
      </InstallationKeyRowKey>
      <CopyTextButton
        buttonText=""
        value={keyCode}
        css={{ marginInlineStart: '$4', flex: '0.5' }}
      />
    </InstallationKeyRowStyled>
  )
}
